import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  toolbarContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& .labelDate': {
      color: theme.palette.text.primary,
      fontSize: 'initial',
      marginBottom: '5px',
    },
  },
}));
const CustomToolbar = toolbar => {
  const classes = useStyles();
  const label = () => {
    return <span>{toolbar.label}</span>;
  };
  return (
    <div className={classes.toolbarContainer}>
      <label className={'labelDate'}>{label()}</label>
    </div>
  );
};

export default CustomToolbar;
